import  { ADD } from '../../utility/AppConstants'
const CoursesReducer=(state={}, action)=>{
    if(action.type === 'SET_LOADING_COURSES'){
        return{
            ...state,
            loading: action.payload.loading,
        }
    }
    else if(action.type === 'SET_COURSES'){
        console.log('ssssssssssssssssssssss')
        console.log(state.courseDetails)
        if(state.courseDetails!==undefined && state.courseDetails!==null){
            let courseDetailsTemario = state.courseDetails.temario
            let courseDetailsClases = state.courseDetails.clases
            let newCourseDetails = action.payload.courses.filter(course => course.idCurso === state.courseDetails.idCurso)

            newCourseDetails[0].temario = courseDetailsTemario
            newCourseDetails[0].clases = courseDetailsClases

            return{
                ...state,
                courses: action.payload.courses,
                courseDetails: newCourseDetails[0],
                loading: action.payload.loading,
            }
        }
        return{
            ...state,
            courses: action.payload.courses,
            loading: action.payload.loading,
        }
    }
    else if(action.type === 'SET_AVAILABLE_COURSES'){
        return{
            ...state,
            availableCourses: action.payload.courses,
            loading: action.payload.loading,
        }
    }
    else if(action.type === 'SET_UPDATED_DATA_COURSE'){
        return{
            ...state,
            updatedData: action.payload.updatedData,
            loading: action.payload.loading,
        }
    }
    else if(action.type === 'COURSE_DETAILS'){
        return{
            ...state,
            showDetails: action.payload.showDetails,
            courseDetails: action.payload.courseDetails,
        }
    }
    else if(action.type === 'UPDATE_TEACHER_IN_COURSE_DETAILS'){
        // Buscar el salón que contiene una clase con ese id
        /*const salonEncontrado = action.payload.courseDetails.salones.find(salon =>
            salon.clases.some(clase => clase.idClase === action.payload.idClassUpdated)
        );

        const claseEncontrada = salonEncontrado.clases.find(clase => clase.idClase === action.payload.idClassUpdated);

        console.log("salon encontradoooo!! ")
        console.log(salonEncontrado);
        console.log("clase encontradoooo!! ")
        console.log(claseEncontrada);*/
        const classUpdated = action.payload.classUpdated;

        console.log("clase encontradoooo!! ")
        console.log(classUpdated);
        console.log("current state ")
        console.log(state.courseDetails);

        return {
            ...state,
            courseDetails: {
                ...state.courseDetails,
                salones: state.courseDetails.salones.map(salon => ({
                    ...salon,
                    clases: salon.clases.map(clase =>
                        clase.idClase === classUpdated.idClase
                            ? { ...clase, instructor: classUpdated.instructor }
                            : clase
                    )
                }))
            },
            showDetails: action.payload.showDetails
        }

        /*return{
            ...state,
            showDetails: action.payload.showDetails,
            courseDetails: action.payload.courseDetails,
        }*/
    }
    else if(action.type === 'UPDATE_COURSE_FAIL'){
        return{
            ...state,
            updateCourseFail: action.payload.updateCourseFail
        }
    }
    else if(action.type === 'REFRESH_COURSES_IN_COURSES'){
        return{
            ...state,
            refreshCoursesInCourses: action.payload.refreshCoursesInCourses,
        }
    }
    else if(action.type === 'DELETE_CLASS'){
         //action.payload.classroomId
        //state.courseDetails.salones.find(classroom => classroom.idSalon === action.payload.classroomId).clases.filter( clase => clase.idClase !== action.payload.idClass)
        let classroomToUpdate  = state.courseDetails.salones.find(classroom => classroom.idSalon === action.payload.classroomId)
        let newClasses = classroomToUpdate.clases.filter( clase => clase.idClase !== action.payload.idClass)

        classroomToUpdate.clases = newClasses
        return{
            ...state
        }
    }
    else if(action.type === 'ADD_CLASS'){
        state.courseDetails.salones.find(classroom => classroom.idSalon === action.payload.newClass.idSalon).clases.push(action.payload.newClass) 
        //state.courseDetails.clases.push(action.payload.newClass) 
        return{
            ...state
        }
    }
    else if(action.type === 'ADD_LESSON'){
        state.courseDetails.temario.push(action.payload.newLesson) 
        return{
            ...state,
            addedLesson:true
        }
    }
    else if(action.type === 'LESSON_ADDED'){
        return{
            ...state,
            addedLesson:action.payload.addedLesson
        }
    }
    else if(action.type === 'DELETE_LESSON'){
        let newLessons = state.courseDetails.temario.filter( tema => tema.idTema !== action.payload.idLessonDelete )
        let course = state.courseDetails
        course.temario = newLessons;
        return{
            ...state,
            courseDetails: course,
        }
    }
    else if(action.type === 'UPDATE_LESSON_MODAL'){
        return{
            ...state,
            updateLessonModal: action.payload.updateLessonModal,
            lesson: action.payload.lesson,
        }
    }
    else if(action.type === 'LESSON_EDITED'){
        state.courseDetails.temario.forEach(tema => {
            if(tema.idTema === action.payload.lessonEdited.idTema){
                tema.tituloTema = action.payload.lessonEdited.tituloTema
                tema.descripcionTema = action.payload.lessonEdited.descripcionTema
            }
        })
        return{
            ...state
        }
    }
    else if(action.type === 'ASSISTANCE_MANAGEMENT_MODAL'){
        return{
            ...state,
            assistanceManagementModal: action.payload.assistanceManagementModal,
            assistanceIdClass: action.payload.assistanceIdClass
        }
    }
    else if(action.type === 'STUDENT_COURSE_DETAILS'){
        state.courseDetails = action.payload.studentCourseDetails.curso
        state.courseDetails.vencimiento = action.payload.studentCourseDetails.vencimiento
        state.courseDetails.bloqueo = action.payload.studentCourseDetails.bloqueo
    
        return{
            ...state,
            showDetails: action.payload.showDetails
        }
    }
    else if(action.type === 'USER_ENROLLED_UPDATE_BY_STUDENT'){
        let registered = (action.payload.action===ADD)?true:false
        
        /*for (let courseClass of state.courseDetails.clases) {
            if(courseClass.idClase === action.payload.idClase) {
                courseClass.availability = (action.payload.action===ADD) ? courseClass.availability-1 : courseClass.availability+1
                courseClass.registred = registered
                break;
            }
        } 
        return{
            ...state,
            loading: action.payload.loading,
            refreshCoursesInCourses: action.payload.refreshCoursesInCourses
        }*/


        return {
            ...state,
            courseDetails: {
                ...state.courseDetails,
                salones: state.courseDetails.salones.map(salon => ({
                    ...salon,
                    clases: salon.clases.map(clase =>
                        clase.idClase === action.payload.idClase
                            ? { ...clase, registred: registered, availability:(action.payload.action===ADD) ? clase.availability-1 : clase.availability+1  }
                            : clase
                    )
                }))
            },
            loading: action.payload.loading,
            refreshCoursesInCourses: action.payload.refreshCoursesInCourses
        }
         
    }
    else if(action.type === 'SET_LESSONS_TO_COURSE'){
        state.availableCourses[action.payload.courseIndex].lessons = action.payload.courseLessons
        return{
            ...state,
            showCourseLessons: action.payload.showCourseLessons,
            courseInformation: state.availableCourses[action.payload.courseIndex]
        }
    }
    else if(action.type === 'SET_SHOW_COURSE_LESSONS'){
        
        return{
            ...state,
            showCourseLessons: action.payload.showCourseLessons
        }
    }
    else if(action.type === 'SET_COURSE_INFORMATION'){
        
        return{
            ...state,
            courseInformation: action.payload.courseInformation
        }
    }
    else if(action.type === 'SET_NEW_CLASSROOM'){

        if(state.courseDetails!==undefined && state.courseDetails.idCurso === action.payload.classroom.idCurso){
            //state.courseDetails.salones.unshift( action.payload.classroom)
            // Crear una nueva copia de salones con el nuevo salón al inicio
            const updatedSalones = [action.payload.classroom, ...state.courseDetails.salones];
             return {
                ...state,
                courseDetails: {
                    ...state.courseDetails,
                    salones: updatedSalones
                },
                loading: action.payload.loading,
                refreshCoursesInCourses: true
            };
        }        
        return{
            ...state,
            loading: action.payload.loading,
            refreshCoursesInCourses: true
        }
    }
    else if(action.type === 'SET_REMOVE_CLASSROOM'){

        if(state.courseDetails!==undefined && state.courseDetails.idCurso === action.payload.classroom.idCurso){
            const updatedSalones = state.courseDetails.salones.filter(
                classroom => classroom.idSalon !== action.payload.classroom.idSalon
            );

            return {
                ...state,
                courseDetails: {
                    ...state.courseDetails,
                    salones: updatedSalones
                },
                loading: action.payload.loading,
                refreshCoursesInCourses: true
            };
        }
        else{
            return{
                ...state,
                loading: action.payload.loading,
                refreshCoursesInCourses: true
            }
        }    
    }
    else if(action.type === 'SET_UPDATE_CLASSROOM'){
        console.log(action.payload.classroom)
    
        return{
            ...state,
            loading: action.payload.loading,
            courseDetails: {
                ...state.courseDetails,
                salones: state.courseDetails.salones.map(salon =>
                    salon.idSalon === action.payload.classroom.idSalon
                        ? action.payload.classroom
                        : salon
                )
            }
        }
    }
    else {
        return state
    }
}
export default CoursesReducer;